import React from 'react';
import { Link } from 'react-router-dom';

const CourseCTA = (props) => {
  const course = props.course;
  return (
    <header className='course-detail__header'>
			<h1>{course.title} Course</h1>
			<div className='course-detail__header-cta'>
				<Link to={{pathname: '/join', state: { course: course }}}
          className='button button--s'>
            Free Trial
        </Link>
				<Link to={{pathname: '/checkout/register', state: { course: course }}}
          className='button button--pri button--s'>
            Buy Now
        </Link>
			</div>
			<div className='course-detail__price'>
				£{course.courseOptions[0].price}&nbsp;
				<span className='course-detail__instalments'>
          Or {course.courseOptions[0].instalmentDurationMonths} monthly instalments of £{course.courseOptions[0].instalmentPrice} <em>(inc 5% fee)</em>
        </span>
			</div>
		</header>
  )
};

export default CourseCTA;



// WEBPACK FOOTER //
// ./src/components/CourseCTA/index.js